module.exports = __webpack_public_path__ + "static/media/request-icon.a231e268.svg";